import { CreatedAt } from '../Document/CreatedAt.js';
import { BlockLink } from './BlockLink.js';
import { GetStrTotal } from '../Functions/GetStrTotal.js';
import { UCFirst } from '../Functions/UCFirst.js';

export const BlockTitleDate1Link2 = (props) => {
    /*
    Pages/Public/Attraction.js
    Pages/Public/Character.js
    Page/Public/RendezVousPersonnage.js
    */
    const { label, items, author } = props;
    let values;
    switch (label) {
        case 'attraction':
        case 'character':
        case 'rendez-vous-personnage':
            if (label === 'attraction') {
                values = [
                    { created: items.created, name: UCFirst(items.aname), author: author },
                    { href: `/categorie/${items.cslug}`, name: UCFirst(items.cname) },
                    { href: `/origine/${items.oslug}`, name: UCFirst(items.oname) },
                    { strTotal: `${items.total} ${GetStrTotal(label, items.total)}` },
                ];
            }
            if (label === 'character') {
                values = [
                    { created: items.created, name: UCFirst(items.cname), author: items.author },
                    { href: `/personnages`, name: `Personnages` },
                    { href: items.oroute, name: items.oname },
                    { strTotal: `${items.total} ${GetStrTotal(label, items.total)}` },
                ];
            }
            if (label === 'rendez-vous-personnage') {
                values = [
                    { created: items.created, name: `Rendez-vous\npersonnage Disney`, author: items.author },
                    { href: '/rendez-vous', name: 'rendez-vous' },
                    { href: items.oroute, name: items.oname },
                    { strTotal: `${items.total} ${GetStrTotal(label, items.total)}` },
                ];
            }
            return (
                <div className="block-title">
                    <CreatedAt date={values[0].created} />
                    <div className="title">
                        <div className="title-name">{values[0].name}</div>
                        <div className="title-total-label">{values[3].strTotal}</div>
                        <div className="title-author">{values[0].author}</div>
                        <BlockLink label="link-true" href={values[1].href} name={values[1].name} />
                        <BlockLink label="link-true" href={values[2].href} name={values[2].name} />
                    </div>
                </div>
            )
        default:
            return (
                <></>
            )
    }
}